import { render, staticRenderFns } from "./UserListTable.vue?vue&type=template&id=72c5c92f&scoped=true&lang=html&"
import script from "./UserListTable.vue?vue&type=script&lang=js&"
export * from "./UserListTable.vue?vue&type=script&lang=js&"
import style0 from "./UserListTable.vue?vue&type=style&index=0&id=72c5c92f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c5c92f",
  null
  
)

export default component.exports